/**
 * BF+ Shared email subscribe → Shopify Customer API
 * Posts to /contact with form_type=customer.
 * Customers appear in Shopify Admin > Customers with the supplied tag.
 */
async function bfSubscribe(e, form, tag) {
  e.preventDefault();
  var input = form.querySelector('input[type="email"]');
  var btn   = form.querySelector('button');
  var email = input.value.trim();
  if (!email) return;

  btn.disabled = true;
  btn.textContent = '⋯';

  try {
    await fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=customer&utf8=%E2%9C%93'
        + '&contact[email]=' + encodeURIComponent(email)
        + '&contact[tags]='  + encodeURIComponent(tag)
    });
    btn.textContent = '✓ 已登記';
    btn.style.background  = 'var(--orange-deep)';
    btn.style.borderColor = 'var(--orange-deep)';
    btn.style.color       = '#fff';
    input.disabled = true;
    var note = form.querySelector('.split-note, .notify-note')
            || (form.parentElement && form.parentElement.querySelector('.split-note'));
    if (note) note.textContent = '網店開張時會第一時間通知你 · You’re on the list';
  } catch (err) {
    btn.textContent = '再試 Retry';
    btn.disabled = false;
  }
}
